import React from 'react';
import type { ShareLink } from './types';

interface ShareButtonProps {
  link: ShareLink;
}

export function ShareButton({ link }: ShareButtonProps) {
  const Icon = link.icon;
  
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      title={link.name}
      className="p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow flex items-center justify-center"
    >
      <Icon className="w-5 h-5" />
    </a>
  );
}